import { render, staticRenderFns } from "./editAttr.vue?vue&type=template&id=d59d756e&scoped=true"
import script from "./editAttr.vue?vue&type=script&lang=js"
export * from "./editAttr.vue?vue&type=script&lang=js"
import style0 from "./editAttr.vue?vue&type=style&index=0&id=d59d756e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59d756e",
  null
  
)

export default component.exports